import { render } from "./Dashboard.vue?vue&type=template&id=3e93c5b7&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3e93c5b7"

export default script